import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DashboardGridComponent } from '../dashboard-grid/dashboard-grid.component';
import { DashboardLeaderComponent } from '../dashboard-leader/dashboard-leader.component';
import { FormsModule } from '@angular/forms';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { DpTableComponent } from '../../../common-component/dp-table/dp-table.component';
// import { DpTabMenuComponent } from '../../../common-component/dp-tab-menu/dp-tab-menu.component';
import { ActivatedRoute, NavigationEnd, Route, Router, RouterOutlet } from '@angular/router';
import { LoaderComponent } from '../../../common-component/loader/loader.component';
import { RequestMapper } from '../../../request-mapper';
import { RefreshedDateKey } from '../../../enum/refresh-date';
import { MasterSearchTransmissionService } from '../../../services/raintree/Transmission/master-search.service';
import { DpTabMenuV3Component } from '../../../common-component/dp-tab-menu-v3/dp-tab-menu-v3.component';
import { AppConfigService } from '../../../services/config/app-config.service';
import { filter } from 'rxjs/operators';
@Component({
  standalone: true,
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: [
    './dashboard.component.scss',
    '../../../../styles/_dropdown.scss',
  ],
  providers: [DatePipe],
  imports: [
    DashboardGridComponent,
    DashboardLeaderComponent,
    CommonModule,
    FormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatButtonModule, LoaderComponent,
    MatFormFieldModule,
    MatIconModule,
    MatDividerModule,
    DpTableComponent, DpTabMenuV3Component, RouterOutlet
  ],
})
export class DashboardComponent implements OnInit {
  isMobileDevice: boolean = false;
  breadcrumbs: any[] = ['All countries']
  country: string = 'India';
  isLoading: boolean = false
  myStatsPage: boolean = false
  lastRefreshDate: any
  routeSubscription: any
  currentUrl: string[] = []
  @ViewChild(DpTabMenuV3Component) otherComponent!: DpTabMenuV3Component;
  public isGridView: boolean = false;
  public isListView: boolean = true;
  constructor(private isMobile: CommonUtilService,
    private _activatedRoute: ActivatedRoute,
    private masterSearchService: MasterSearchTransmissionService,
    private router: Router,
    private datePipe: DatePipe,
    private appConfigS: AppConfigService
  ) {
  }
  ngOnInit(): void {
    const allPermissionsV3: any = this.appConfigS.getAllPermissionsV3();
    this.country = Object.keys(allPermissionsV3["Statistics"]["default"]["PERMISSION"])[0];
    this.isLoading = true
    this.isGridView = false;
    this.isListView = true;
    this.isMobileDevice = this.isMobile.isMobileDevice();
    localStorage.setItem('delete-district', '0')
    localStorage.setItem('delete-state', '0')
    setTimeout(() => {
      const perm: any = this.otherComponent.fetchTabDetails()
      if (perm?.length === 1 && perm[0].webRoute === RequestMapper.MY_STATS)
        this.myStatsPage = true
      this.addBreadCrumbs()
      this.removeBreadCrumbs(false)
      this.isLoading = false
    }, 1);
    // this.fetchLastRefresheDate()
    this.routeSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.fetchLastRefresheDate()
      }
      
    });

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = event.urlAfterRedirects.split('/');
        console.log('Parent detected URL:', this.currentUrl);
        if(this.currentUrl[2] === 'ritwik_report'){
          this.breadcrumbs = ['Financial year']
        }
      });
    
  }
  fetchLastRefreshedDateAllReports() {
    this.masterSearchService.fetchLastRefreshDate().subscribe({
      next: (response: any) => {
        localStorage.setItem('refresh-date', btoa(encodeURIComponent(JSON.stringify(response.data))))
      }, error: (error: any) => {
        console.log(error)
      }
    })
  }
  fetchLastRefresheDate() {
    let routeNames: any
    if (this.router.url.includes('?')) {
      routeNames = this.router.url.split('?')[0];
    }
    routeNames = this.router.url.split('/')
    let refreshDate: any = JSON.parse(decodeURIComponent(atob(localStorage.getItem('refresh-date')!)))
    if (routeNames[2] === 'all-reports' && !refreshDate) {
      this.fetchLastRefreshedDateAllReports()
    }
    if (refreshDate) {
      let keyName: any = (routeNames[2].includes('all-reports') || routeNames[2].includes(RequestMapper.MY_STATS)) ? RefreshedDateKey.AllReport : routeNames[2]?.includes('phase') ? RefreshedDateKey.PhilReport : routeNames[2]?.includes(RequestMapper.DASHBOARD_USER_REPORT) ? RefreshedDateKey.wishlistItems : ''
      if (keyName !== '' && keyName) {
        this.lastRefreshDate = refreshDate.filter((item: any) => item.configName.includes(keyName))
        this.lastRefreshDate = this.datePipe.transform(this.lastRefreshDate[0]?.date, 'MMM d, y')
      } else
        this.lastRefreshDate = ''
    }
  }
  addBreadCrumbs() {
    //  let routeNames: any
    //  routeNames = this.currentUrl.split('/')
    //  console.log(routeNames);
     

    this._activatedRoute.queryParams.subscribe((params) => {
      if(this.currentUrl[2] !== 'ritwik_report'){
      if (params['country'] && params['district'] && params['state'] && this.breadcrumbs.length === 1)
        this.breadcrumbs.push(params['country'], params['state'], params['district'])
      if (params['country'] && params['district'] && params['state'] && this.breadcrumbs.length === 2)
        this.breadcrumbs.push(params['state'], params['district'])
      if (params['country'] && params['state'] && !params['district'] && this.breadcrumbs.length === 4)
        this.breadcrumbs.pop()
      if (params['state'] && this.breadcrumbs.length === 2) {
        this.breadcrumbs.push(params['state']);
      }
      if (params['state'] && this.breadcrumbs.length === 3) {
        this.breadcrumbs[2] = params['state'];
      }
      if (params['district'] && this.breadcrumbs.length === 3) {
        this.breadcrumbs.push(params['district']);
      }
      if (params['district'] && this.breadcrumbs.length === 4) {
        this.breadcrumbs[3] = params['district'];
        this.breadcrumbs[2] = params['state']
      }
      if (params['pincode'] && this.breadcrumbs.length === 4) {
        this.breadcrumbs.push(params['pincode']);
      }
      if (params['pincode'] && this.breadcrumbs.length === 5) {
        this.breadcrumbs[4] = params['pincode'];
      }
      if (params['country'] && this.breadcrumbs.length === 1) {
        this.breadcrumbs.push(params['country']);
      }
      this.isLoading = false;
    }else{
      if (params['year'] && this.breadcrumbs.length === 1){
        this.breadcrumbs.push(params['year'])
      }
    }
    });
  }
  onBreadcrumbClick(index?: any) {
    this.isLoading = true
    // if(index>=1){
    this.breadcrumbs.splice(index + 1)
    this.removeBreadCrumbs(true)
    // }
  }
  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }
  removeBreadCrumbs(type: boolean) {
    let queryParams = { ...this._activatedRoute.snapshot.queryParams };
    if (type) {
      if (this.breadcrumbs.length === 1) {
        localStorage.setItem('delete-state', '')
        localStorage.setItem('delete-district', '')
        delete queryParams['district'];
        delete queryParams['state'];
        delete queryParams['country'];
        delete queryParams['pincode'];
        delete queryParams['year']
      }
      else if (this.breadcrumbs.length === 2) {
        localStorage.setItem('delete-state', '')
        localStorage.setItem('delete-district', '')
        delete queryParams['state'];
        delete queryParams['district'];
        delete queryParams['pincode'];
      }
      else if (this.breadcrumbs.length === 4) {
        delete queryParams['pincode'];
      }
      else {
        localStorage.setItem('delete-district', '')
        delete queryParams['district'];
        delete queryParams['pincode'];
      }
      this.router.navigate([], {
        relativeTo: this._activatedRoute,
        queryParams: queryParams,
      });
    } else {
      this._activatedRoute.queryParams.subscribe((params) => {
        if (Object.keys(params).length === 0 && this.breadcrumbs.length > 1) {
          this.breadcrumbs = ['All countries']
        }
      });
    }
  }
  public showView(type: any) {
    if (type === 'GRIDE') {
      this.isGridView = true;
      this.isListView = false;
    } else if (type === 'LIST') {
      this.isGridView = false;
      this.isListView = true;
    } else {
      this.isGridView = true;
      this.isListView = false;
    }
  }
}
